import React, { useEffect, useState } from 'react';
import { useAuthenticated } from 'react-admin';
import { useDispatch, useSelector } from 'react-redux';
import * as Sentry from '@sentry/browser';
import {
  EndTaskDialog,
  TestTechnicianLogin,
  MaterialDialog,
  ItsMaterialDialog,
  AppBar,
  TaskDetails,
  NotificationsDialog,
  UsedMaterialsDialog,
  ConfirmationDialog,
  TaskCards,
  TestImageUpload,
  DebugLog,
  RefreshAppButton,
  AutomaticTestDialog,
  ForceCloseTask,
  DocumentsDashboard,
  RejectSignatureRequestDialog,
} from './components';

import ErrorBoundary from './ErrorHandling/ErrorBoundary';
import MaterialsSellDialog from './components/MaterialsSellDialog';
import CreatePinDialog from './components/CreatePinDialog';
import ConfirmMaterialsDialog from './components/ConfirmMaterialsDialog';
import { asyncFetch } from '../helperFunctions';
import { LOAD_USER_SUCCESS } from '../ReactAdminOss._Core/src/reducers/Auth/actionTypes';
import ResetPasswordAndroidBoxDialog from './components/ResetPasswordAndroidBoxDialog';
import ReturnMaterialsDialog from './components/ReturnMaterialsDialog';
import { ChatDialog, ActiveChatsLoader, ChatNotices, ChatSwitch, chatConfigured } from '../Chat';

export default () => {
  useAuthenticated();

  const [userLoadingState, setUserLoadingState] = useState({ loading: false, loaded: false });

  const loginInfo = useSelector(state => state.auth);
  const { isAdmin, user } = loginInfo;
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      !userLoadingState.loading &&
      !userLoadingState.loaded &&
      loginInfo &&
      loginInfo.isAdmin !== undefined &&
      !loginInfo.user
    ) {
      const ossToken = localStorage.getItem('OSS_Token');
      if (ossToken) {
        setUserLoadingState({ loading: true, loaded: false });
        const parts = [];
        parts.push(ossToken.slice(0, 8));
        parts.push(ossToken.slice(8, 12));
        parts.push(ossToken.slice(12, 16));
        parts.push(ossToken.slice(16, 20));
        parts.push(ossToken.slice(20, 32));
        const GUID = parts.join('-');

        (async () => {
          const response = await asyncFetch(
            `${process.env.REACT_APP_TECHNICIANS_API}/Feature/get-logged-user-by-token?token=${GUID}`
          );

          if (response?.userId) {
            setUserLoadingState({ loading: false, loaded: true });
            dispatch({
              type: LOAD_USER_SUCCESS,
              payload: { user: { ...response, id: response?.id || response?.userId } },
            });
          }
        })();
      }
    }
  }, [loginInfo, userLoadingState, dispatch]);

  useEffect(() => {
    if (user?.id) {
      Sentry.setUser({ id: user.id });
    }
  }, [user]);

  return (
    loginInfo && (
      <ErrorBoundary isAdmin={isAdmin}>
        <AppBar />
        <TaskCards />
        <TaskDetails />
        <MaterialDialog />
        <ReturnMaterialsDialog />
        <ConfirmMaterialsDialog />
        <ItsMaterialDialog />
        <MaterialsSellDialog />
        <CreatePinDialog />
        <ResetPasswordAndroidBoxDialog />
        <EndTaskDialog />
        {chatConfigured && <ChatSwitch />}
        <ChatDialog />
        <ActiveChatsLoader />
        <ChatNotices />
        <UsedMaterialsDialog />
        <NotificationsDialog />
        <ConfirmationDialog />
        <AutomaticTestDialog />
        <TestTechnicianLogin />
        <TestImageUpload />
        {isAdmin && <DebugLog />}
        {isAdmin && <RefreshAppButton />}
        <ForceCloseTask />
        <DocumentsDashboard />
        <RejectSignatureRequestDialog />
      </ErrorBoundary>
    )
  );
};
